import React from 'react';
import { withRouter } from 'react-router-dom'
import {withApollo} from 'react-apollo'
import {withStyles, Link, Avatar, InputBase, Button, IconButton, InputAdornment, Tooltip, Grid} from '@material-ui/core';
import {VerifiedUser, Visibility, VisibilityOff } from '@material-ui/icons';
import session from '../../../model/session'
import PinInput from 'react-pin-input';
import axios from 'axios'
import config from '../../../config/backend'

const styles = {
    container: {
        position:"fixed",
        height:"100%", 
        width:"100%",
        overflowY:"auto",
        background:"#F2F2F2",
        fontFamily:"arial",
    },

    box:{
        margin:"auto",
        height:"90%"
    },

    field:{
        display:"block",
        padding:"0 5px",
        width:"15rem",
        background:"#FAF7EA",
        border:"1px solid #D1D1D1",
        borderRadius:"5px",
        marginBottom:"1em",
    },

    buttons:{
        width:"15rem",
        background:"#D1D1D1",
        color:"#FFFFFF",
    },

    colorButton:{
        background:"#FDAF2A",
    },

    avatar:{
        width:"7rem",
        height:"7rem"
    },
    
    header:{
        fontWeight:"bold",
        fontSize:"1rem",
    }
}
class Landing extends React.Component {
    constructor(props) { //holds data to be parsed into the page
        super(props);
        this.state = {
            users: [],

            pin: "",
            pinComplete: false,

            email: "",
            password: "",
            revealPassword: false,
            error: false,
        };
    }
    
    render() {
        const {
            classes, 
            //handleChange, 
            //handleSignIn, 
            emailValue, 
            passwordValue, 
            error, 
            redirectProps, 
            skipPassword, 
            joining,
            type,
            jbIndex,
            selectedJB
        } = this.props

        return (
         <div style={{ width: "20rem", padding: "2rem", background:"white",borderRadius:"5px" }}>
                <h2 style={{ textAlign: "center" }}>Welcome</h2>
                <Avatar 
                    src={require("../../../element/loginMan.png")} 
                    style={{ width: "6rem", height: "6rem", margin: "0 auto" }} 
                />

                {/* form content */}
                <form onSubmit={(e) => { e.preventDefault(); }}>
                    <InputBase
                    className={classes.field}
                    value={this.state.email}
                    name="email"
                    placeholder="your email address"
                    onChange={this.handleChange}
                    inputProps={{
                        style: { fontSize: "0.875rem", fontFamily: "arial", textAlign: "center" }
                    }}
                    />
                    <InputBase
                    className={classes.field}
                    value={this.state.password}
                    name="password"
                    type={this.state.revealPassword ? "text" : "password"}
                    placeholder="password"
                    onChange={this.handleChange}
                    inputProps={{
                        style: { fontSize: "0.875rem", fontFamily: "arial", textAlign: "center" }
                    }}
                    />

                    <p style={{ textAlign: "center", fontSize: "0.8rem" }}>
                    <Link href="recovery" style={{ cursor: "pointer", fontWeight: "bold", textDecoration: "underline", color: "#E97610" }}>
                        Forgot your password?
                    </Link>
                    </p>

                    <Button
                    type="submit"
                    onClick={this.handleSignIn}
                    fullWidth
                    style={(this.state.password === "" || this.state.email === "") 
                        ? { color: "white", background: "#D1D1D1" } 
                        : { color: "white", background: "#FDAF2A" }}
                    disabled={this.state.password === "" || this.state.email === ""}
                    >
                    LOG IN
                    </Button>

                    <p style={{ textAlign: "center", marginTop: "10px", fontSize: "0.8rem" }}>
                    Need an account?
                    <Link 
                        onClick={() => this.props.history.push("/register")}
                        style={{ cursor: "pointer", marginLeft: "5px", fontWeight: "bold", color: "#E97610" }}
                    >
                        Register
                    </Link>
                    </p>
                </form>
                </div>
        );
    
        
    }

    togglePassword = () =>{
        this.setState(prev =>({
            revealPassword: !prev.revealPassword
        }));
    }

        handleChange = (e) => {
            let n = e.target.name
            this.setState({
                [n]: e.target.value
            })
        }
    
        // Existing User 
        handleSignIn = () => {
            axios.post(`${config.backend.uri}/signin`,{
                email: this.state.email,
                password: this.state.password
            }).then((res)=>{
                
                // if(res.data.user.verified){
                //     if(res.data.user.verified == false){
                //         this.setState({
                //             user: res.data.user,
                //             verification: true
                //         })
                //     }else{
                //         session.setUser(res.data.user);
                //         this.setState({
                //             user: res.data.user
                //         })
                //     }
                // }else{
                //     session.setUser(res.data.user);
                //     this.setState({
                //         user: res.data.user
                //     })
                // }
                if(/*res.data.user.verified == false*/ 1 === 2){
                    this.setState({
                        user: res.data.user,
                        verification: true
                    })
                }else{
                    session.setUser(res.data.user);
                    window.location.reload()
                    // this.setState({
                    //     user: res.data.user
                    // })
                }
    
    
            }).catch(() =>{
                this.handleError()
            })
        }
    
        //Error
        handleError = () =>{
            this.setState({
                error: true
            }, () =>{
                setTimeout(()=>{
                    this.setState({
                        error: false
                    });
                }, 3000)
            });
        } 
}

export default withApollo(withRouter(withStyles(styles)(Landing)))